import React from 'react';
import { AppBar } from '@mui/material';
import { Badge, Container, IconButton, makeStyles, Menu, Typography } from '@material-ui/core';
import { BsBell } from "react-icons/bs";
import { Button } from 'react-bootstrap';
import { useHistory } from "react-router-dom";
import {getDate, getplaceSession, getUser, removeUserSession} from '../Utils/Common';
import { AccountCircle } from '@material-ui/icons';


const useStyles = makeStyles((theme) => ({
    menuButton: {
      marginRight: theme.spacing(2),
    },
    username:{
      fontSize:"1"
    },
    title: {
      marginLeft:theme.spacing(60),
      flexGrow: 1,
      fontWeight:'bold'
    },
    titlee: {
      marginLeft:theme.spacing(-12),
      flexGrow: 1,
    },
    appbar:{
    }
  }));
function Home(props) {
    const classes = useStyles();
    let history = useHistory();

    const logout=()=>{
      removeUserSession();
      history.push('/')
    }
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
   
    const handleMenu = (event) => {
      setAnchorEl(event.currentTarget);
    };
  
    const handleClose = () => {
      setAnchorEl(null);
    };
  return (
    <div style={{marginBottom:'50px'}}>
          <AppBar color='inherit' position="fixed">
          <div className='form-inline'>
            <div className='ml-2'/>
          <Typography variant="h6">
            {getUser()}
          </Typography>
          <IconButton  aria-label="account of current user"aria-controls="menu-appbar"aria-haspopup="true"
          onClick={handleMenu} color="inherit">
 <AccountCircle />
          </IconButton>
          <Menu id="menu-appbar" anchorEl={anchorEl}
          anchorOrigin={{vertical: 'center',horizontal: 'left',}}
          keepMounted transformOrigin={{vertical: 'center',horizontal: 'left',}}
          open={open} onClose={handleClose}>
              <Container>
              <Typography variant="caption" display="block" gutterBottom>{getUser()}</Typography>
                <Typography variant="subtitle2">{getplaceSession()}</Typography>
                <Typography variant="subtitle2">{getDate()}</Typography></Container>
              </Menu>
          <Typography variant="h6" className={classes.title}>
          UNI CHA
          </Typography>
          <IconButton edge="start" className={classes.menuButton} color="inherit" size='small'>
            <Badge variant="dot" color="secondary" overlap="rectangular">
              <BsBell />
            </Badge>
          </IconButton>
          <Button onClick={logout} size='sm'>LOGOUT</Button>
          </div>
      </AppBar>
    </div>
  )
}

export default Home